// Get the base URL from environment variables
// Defaults to development URL if not set
const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://feelbetter-dev.it-mitra.com/api';

export default baseURL;